<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="validate">
      <div>
        <h5 class="info-text">Ahora identifícate con tu documento</h5>
        <div class="md-layout">
          <div class="md-layout-item md-size-30 mx-auto md-xsmall-size-100">
            <div class="file-input">
              <div v-if="!imageF">
                <div class="image-container">
                  <img :src="frontDefault" title="" />
                </div>
              </div>
              <div class="image-container" v-else>
                <img :src="imageF" />
              </div>
              <div class="button-container">
                <md-button
                  class="md-danger md-round"
                  @click="removeImage"
                  v-if="imageF"
                  ><i class="fa fa-times"></i>Eliminar</md-button
                >
                <md-button class="md-primary md-round md-fileinput">
                  <template v-if="!imageF">Foto delantera</template>
                  <template v-else>Cambiar</template>
                  <input
                    type="file"
                    accept="image/png, image/jpeg"
                    @change="onFileChange"
                  />
                </md-button>
              </div>
            </div>
          </div>
          <div class="md-layout-item md-size-30 mx-auto md-xsmall-size-100">
            <div class="file-input">
              <div v-if="!imageB">
                <div class="image-container">
                  <img :src="backDefault" title="" />
                </div>
              </div>
              <div class="image-container" v-else>
                <img :src="imageB" />
              </div>
              <div class="button-container">
                <md-button
                  class="md-danger md-round"
                  @click="removeImage('back')"
                  v-if="imageB"
                  ><i class="fa fa-times"></i>Eliminar</md-button
                >
                <md-button class="md-primary md-round md-fileinput">
                  <template v-if="!imageB">Foto trasera</template>
                  <template v-else>Cambiar</template>
                  <input
                    type="file"
                    accept="image/png, image/jpeg"
                    name="back"
                    @change="onFileChange"
                  />
                </md-button>
              </div>
            </div>
          </div>
          <div class="md-layout-item md-size-100 md-small-size-100">
            <div class="md-layout">
              <div class="md-layout-item md-size-50 md-small-size-100">
                <ApolloQuery
                  :query="require('../../../graphql/query/DomainGroup.gql')"
                  :variables="{ fieldName: Constants.DOMAIN_DOC_TYPE }"
                  ><template v-slot="{ result: { data } }">
                    <ValidationProvider
                      name="capDomainDocType"
                      rules="required"
                      v-slot="{ passed, failed }"
                    >
                      <md-field
                        :class="[
                          { 'md-error': failed },
                          { 'md-valid': passed },
                          { 'md-form-group': true }
                        ]"
                      >
                        <md-icon>picture_in_picture</md-icon>
                        <label for="select">Tipo de Documento</label>
                        <md-select
                          v-if="data"
                          v-model="capDomainDocType"
                          name="select"
                        >
                          <md-option
                            v-for="docType in data.getDomain"
                            :key="docType.id"
                            :value="docType.id"
                            >{{ docType.value }}</md-option
                          >
                        </md-select>
                      </md-field>
                    </ValidationProvider>
                  </template>
                </ApolloQuery>
              </div>
              <div
                class="md-layout-item md-size-50 md-size-40 md-small-size-100"
              >
                <ValidationProvider
                  name="documentValue"
                  rules="required|max_value:99999999999|min_value:1000000"
                  v-slot="{ passed, failed }"
                >
                  <md-field
                    :class="[
                      { 'md-error': failed },
                      { 'md-valid': passed },
                      { 'md-form-group': true }
                    ]"
                  >
                    <md-icon>picture_in_picture_alt</md-icon>
                    <label>Número de documento</label>
                    <md-input v-model="model.documentValue" type="text">
                    </md-input>

                    <slide-y-down-transition>
                      <md-icon class="error" v-show="failed">close</md-icon>
                    </slide-y-down-transition>
                    <slide-y-down-transition>
                      <md-icon class="success" v-show="passed">done</md-icon>
                    </slide-y-down-transition>
                  </md-field>
                </ValidationProvider>
              </div>

              <div class="md-layout-item md-size-50 md-small-size-100">
                <ValidationProvider
                  name="department"
                  rules="required"
                  v-slot="{ passed, failed }"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <md-icon>room</md-icon>
                    <label>Departamento de expedición</label>
                    <md-select
                      v-if="departments"
                      v-model="departmentId"
                      name="select"
                    >
                      <md-option :value="null" disabled
                        >Seleccionar Departamento</md-option
                      >
                      <md-option
                        v-for="department in departments"
                        :key="department.id"
                        :value="department.id"
                        >{{ department.name }}</md-option
                      >
                    </md-select>
                  </md-field>
                </ValidationProvider>
              </div>
              <div class="md-layout-item md-size-50 md-small-size-100">
                <ValidationProvider
                  name="capCityDocExp"
                  rules="required"
                  v-slot="{ passed, failed }"
                >
                  <md-field
                    v-if="department"
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <md-icon>room</md-icon>
                    <label>Ciudad de expedición</label>
                    <md-select v-model="capCityDocExp" name="select">
                      <md-option
                        v-for="city in department.cities"
                        :key="city.id"
                        :value="city.id"
                        >{{ city.name }}</md-option
                      >
                    </md-select>
                  </md-field>
                </ValidationProvider>
              </div>
            </div>

            <div class="md-layout-item  md-small-size-100">
              <md-card>
                <md-card-header class="md-card-header-icon md-card-header-blue">
                  <div class="card-icon">
                    <md-icon>today</md-icon>
                  </div>
                  <h4 class="title">Fecha de expedición</h4>
                </md-card-header>

                <md-card-content>
                  <md-datepicker
                    :md-disabled-dates="disabledDates"
                    v-model="model.documentExpDate"
                  >
                    <label>Selecccionar fecha</label>
                  </md-datepicker>
                </md-card-content>
              </md-card>
            </div>
          </div>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import { extend } from "vee-validate";
import { required, max_value } from "vee-validate/dist/rules";
import Swal from "sweetalert2";
import Constants from "../../../constants";
import gql from "graphql-tag";

extend("required", required);
extend("max_value", max_value);
export default {
  components: { SlideYDownTransition },
  props: {
    frontDefault: {
      type: String,
      default: "./img/capital77/cedula-frontal.webp"
    },
    backDefault: {
      type: String,
      default: "./img/capital77/cedula-trasera.webp"
    }
  },
  created() {
    this.$apollo
      .query({
        query: gql`
          query departments {
            departments {
              id: depId
              name: depName
              cities: capCities {
                id: cityId
                name: cityName
              }
            }
          }
        `
      })
      .then(data => {
        this.departments = data.data.departments;
      });
  },
  data() {
    return {
      model: {
        documentValue: null,
        documentExpDate: new Date()
      },
      disabledDates: date => {
        return Constants.daysOfDifference(new Date(), date) > 0;
      },
      capCityDocExp: null,
      capDomainDocType: null,
      imageFormF: new FormData(),
      imageFormB: new FormData(),
      imageF: null,
      imageB: null,
      department: { cities: [] },
      departmentId: null,
      departments: {},
      Constants: Constants
    };
  },
  methods: {
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      if (e.target.name) {
        this.createImage(files[0], "back");
      } else {
        this.createImage(files[0]);
      }
    },
    createImage(file, type) {
      let reader = new FileReader();
      let vm = this;
      var partsName = file.name.split(".");
      var extension = partsName[partsName.length - 1];

      if (
        extension.toLowerCase() == "jpeg" ||
        extension.toLowerCase() == "png" ||
        extension.toLowerCase() == "jpg"
      ) {
        reader.onload = e => {
          if (type === "back") {
            vm.imageB = e.target.result;
            vm.imageFormB.set(
              "files",
              file,
              "DocIdentificacionTrasera." + extension
            );
          } else {
            vm.imageF = e.target.result;
            vm.imageFormF.set(
              "files",
              file,
              "DocIdentificacionFrontal." + extension
            );
          }
        };
        reader.readAsDataURL(file);
      } else {
        Swal.fire({
          title: "¡Un segundo!",
          text: "Sólo puedes cargar imágenes en formato jpg, jpeg o png",
          timer: 2000,
          showConfirmButton: false
        });
      }
    },
    removeImage: function(type) {
      if (type === "back") {
        this.imageB = "";
      } else {
        this.imageF = "";
      }
    },
    validate() {
      if (!this.model.documentExpDate) {
        Swal.fire({
          title: "¡Falta algo!",
          text: "No olvides la fecha de expedición",
          timer: 2000,
          showConfirmButton: false
        });
      } else if (!this.imageF || !this.imageB) {
        Swal.fire({
          title: "¡Falta algo!",
          text: "No olvides las fotos de tu cédula",
          timer: 2000,
          showConfirmButton: false
        });
      } else
        return this.$refs.form.validate().then(res => {
          this.$emit(
            "on-validated",
            res,
            this.model,
            this.imageFormF,
            this.imageFormB,
            this.capCityDocExp,
            this.capDomainDocType
          );
          return res;
        });
    }
  },
  watch: {
    departmentId() {
      this.department = this.departments.filter(obj => {
        return obj.id === this.departmentId;
      })[0];
    }
  }
};
</script>
<style></style>
